import { type SharedNameplateTable, sharedNameplateEntries } from '@rock/brands';
import { SharedNameplateDao } from '@rock/db-admin';
import { atom } from 'jotai';

const sharedNameplateDao = new SharedNameplateDao();

/** Every shared nameplate, live — the Shared Nameplates page. */
export const sharedNameplatesState = sharedNameplateDao.sharedNameplatesAtom();

/**
 * The routing table every planner gate in admin takes (Add Brand, alias-add, the request suggester, the
 * merge planner's refusals). Read from the collection, not the index, so a nameplate the wizard just
 * wrote gates the next edit without waiting for a rebuild.
 */
export const sharedNameplateTableState = atom(
    async (get): Promise<SharedNameplateTable> => sharedNameplateEntries(await get(sharedNameplatesState)),
);
